var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.25,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#5775FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.25,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white",
    strokeWidth: 1.875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.207 13.8867L10.9987 24.095V26.25H13.1537L23.362 16.0417L21.207 13.8867ZM22.3854 12.7083L24.5404 14.8633L25.6537 13.75L23.4987 11.595L22.3854 12.7083ZM24.0879 9.82748L27.4212 13.1608C27.5774 13.3171 27.6652 13.529 27.6652 13.75C27.6652 13.971 27.5774 14.1829 27.4212 14.3392L14.0879 27.6725C13.9316 27.8288 13.7197 27.9166 13.4987 27.9167H10.1654C9.94435 27.9167 9.73239 27.8289 9.57611 27.6726C9.41983 27.5163 9.33203 27.3043 9.33203 27.0833V23.75C9.33208 23.529 9.41991 23.3171 9.5762 23.1608L22.9095 9.82748C23.0658 9.67126 23.2777 9.5835 23.4987 9.5835C23.7197 9.5835 23.9316 9.67126 24.0879 9.82748ZM26.832 26.25C27.053 26.25 27.265 26.3378 27.4213 26.4941C27.5776 26.6503 27.6654 26.8623 27.6654 27.0833C27.6654 27.3043 27.5776 27.5163 27.4213 27.6726C27.265 27.8289 27.053 27.9167 26.832 27.9167H18.4987C18.2777 27.9167 18.0657 27.8289 17.9094 27.6726C17.7532 27.5163 17.6654 27.3043 17.6654 27.0833C17.6654 26.8623 17.7532 26.6503 17.9094 26.4941C18.0657 26.3378 18.2777 26.25 18.4987 26.25H26.832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileImage);
export default __webpack_public_path__ + "static/media/edit-profile-image.862bf173095248c53a17aee83a959f0d.svg";
export { ForwardRef as ReactComponent };